import { createApiRef } from "@backstage/core-plugin-api";
import type { GoogleClient } from "@internal/backstage-plugin-google-common";

/**
 * ApiRef for the Google plugin client.
 *
 * @public
 */
export const googleApiRef = createApiRef<GoogleClient>({
    id: "plugin.google.service",
});
